import { useState, useCallback } from 'react';

const CLOSE_DURATION = 200;

/**
 * useModalTransition — handles animated modal close.
 * Sets `isClosing=true` → plays exit animation → then calls onClose after CLOSE_DURATION ms.
 */
export default function useModalTransition(onClose) {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = useCallback(() => {
    if (isClosing) return;
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose?.();
    }, CLOSE_DURATION);
  }, [isClosing, onClose]);

  return { isClosing, handleClose };
}
